import React, { useState, useEffect } from "react";
import SideBar from "../../../components/sidebar";
import Header from "../../../components/header";
import "../../../assets/CSS/dashboard.css";
import "../../../assets/CSS/forms.css";
import API_BASE_URL from "../../../config";
import DivisionReportTable from "./division-wise-report";

function DivisionWiseReport() {
  const [report, setReport] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [loader, setLoader] = useState(false);
  const [divisionQuery, setDivisionQuery] = useState("");
  const [divisionOptions, setDivisionOptions] = useState([]);
  const [query, setQuery] = useState({
    startDate: "",
    endDate: "",
    division: "",
  });

  useEffect(() => {
    if (!divisionQuery) {
      setDivisionOptions([]);
      return;
    }

    const delayDebounce = setTimeout(() => {
      fetch(`${API_BASE_URL}/api/division-options?query=${divisionQuery}`)
        .then((res) => res.json())
        .then((data) => {
          setDivisionOptions(data.divisions.map((d) => d.name));
        })
        .catch((err) => console.error("Error fetching:", err));
    }, 400);

    return () => clearTimeout(delayDebounce);
  }, [divisionQuery]);

  return (
    <div>
      {loader && (
        <div className="loader">
          <div className="loader-spinner"></div>
        </div>
      )}
      <SideBar />
      <div className="main-content">
        <Header />

        <div id="form-content">
          <div id="form-header" style={{ textTransform: "uppercase" }}>
            <p>Division Wise Report</p>
          </div>
          <hr />
          <form id="form">
            <div id="form-input">
              <label>
                Start Date<span className="required">*</span>
              </label>
              <input
                type="date"
                name="startDate"
                placeholder="Select Start Date"
                value={query.startDate}
                onChange={(e) => {
                  setQuery({ ...query, startDate: e.target.value });
                  setReport(false);
                  setButtonClicked(false);
                }}
                required
              />
            </div>
            <div id="form-input">
              <label>
                End Date<span className="required">*</span>
              </label>
              <input
                type="date"
                name="endDate"
                placeholder="Select End Date"
                value={query.endDate}
                onChange={(e) => {
                  setQuery({ ...query, endDate: e.target.value });
                  setReport(false);
                  setButtonClicked(false);
                }}
                required
              />
            </div>
            <div id="form-input">
              <label htmlFor="division">
                Division Name<span className="required">*</span>
              </label>
              <input
                type="text"
                name="division"
                id="division"
                placeholder="Select Division Name"
                list="division-options"
                value={divisionQuery}
                onChange={(e) => {
                  setDivisionQuery(e.target.value);
                  setQuery({ ...query, division: e.target.value });
                  setReport(false);
                  setButtonClicked(false);
                }}
                autoComplete="off"
                required
              />
              <datalist id="division-options">
                {divisionOptions.map((option, index) => (
                  <option key={index} value={option} />
                ))}
              </datalist>
            </div>
          </form>
          <div className="button">
            <button
              type="button"
              className="btn"
              id="search"
              onClick={() => {
                setReport(true);
                setLoader(true);
                setButtonClicked(true);
              }}
              disabled={buttonClicked}
            >
              SEARCH
            </button>
          </div>
        </div>
        {report && <DivisionReportTable query={query} setLoader={setLoader} />}
      </div>
    </div>
  );
}
export default DivisionWiseReport;
